module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Medium.57bc967.ttf";